import { axiosInstance } from 'api/axios';
import moment from 'moment';
import React from 'react';

interface State { hasError: boolean; message: string; stack: string }

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false, message: '', stack: '' };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error?.message ?? String(error), stack: '' };
  }

  async componentDidCatch(error: Error, info: React.ErrorInfo) {
    const componentStack = info?.componentStack?.toString() ?? '';
    // Udostępnij ślad komponentu w fallbacku, aby błąd był diagnozowalny bez konsoli.
    this.setState({ stack: componentStack });
    const time = moment().toJSON();
    const url = window.location.href;
    try {
      await axiosInstance.post('/logger', {
        message: `${error.toString()} stack: ${componentStack}`,
        level: 'error',
        url: url,
        timestamp: time,
      });
    } catch {
      // swallow logging errors
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 32, color: '#c00', fontFamily: 'sans-serif' }}>
          <strong>Wystąpił błąd aplikacji.</strong>
          <pre style={{ marginTop: 12, fontSize: 12, color: '#555', whiteSpace: 'pre-wrap' }}>
            {this.state.message}
          </pre>
          {this.state.stack && (
            <pre style={{ marginTop: 8, fontSize: 11, color: '#999', whiteSpace: 'pre-wrap', maxHeight: 200, overflow: 'auto' }}>
              {this.state.stack}
            </pre>
          )}
          <button
            style={{ marginTop: 16, padding: '6px 16px', cursor: 'pointer' }}
            onClick={() => this.setState({ hasError: false, message: '', stack: '' })}
          >
            Spróbuj ponownie
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
